module.exports = __webpack_public_path__ + "static/media/tag-add-filled.412b15af.svg";